/** Responsive utilities for layouts and breakpoints.
 * 💥 Please sync tokens with responsive css tokens : scss/@evc/responsive/index.scss 💥 */

export const layoutCutoff = 800 as const;

export const breakpoints = {
  mobile: 520,
  tablet: layoutCutoff,
  desktop: 1024,
  desktopSmall: 1280,
  desktopMedium: 1440,
  desktopLarge: 1600,
  hd: 1920,
} as const;

export type Breakpoint = keyof typeof breakpoints;
